import _t from 'i18n!nls/enterprise-legacy-learner-home';

/**
 * This function is used to get the copy for the Xdp Degree Card. It takes an optional duration parameter which can be a string or null.
 * The function initializes an array with a translated string 'Degree' using the i18n internationalization library.
 * If a duration is provided, it is added to the array. The function then returns this array.
 *
 * @param {string | null} duration - An optional parameter that represents the duration. If provided, it is added to the array.
 * @returns {string[]} An array containing the translated string 'Degree' and, if provided, the duration.
 */
export const getXdpDegreeCardCopy = (duration?: string | null): string[] => {
  const creditCopyArray = [_t('Degree')];

  if (duration) {
    creditCopyArray.push(duration);
  }

  return creditCopyArray;
};
